import { Breadcrumb, PageContainer, PageHeader } from "@repo/ui";
import { CarteTemplatesRapports } from "./CarteTemplatesRapports";

export function Parametres() {
  return (
    <PageContainer>
      <Breadcrumb items={[{ label: "Organisations", href: "/" }, { label: "Paramètres" }]} />
      <PageHeader
        titre="Paramètres"
        sousTitre="Réglages de la plateforme, communs à toutes les organisations"
      />
      <div className="space-y-6">
        <CarteTemplatesRapports />
      </div>
    </PageContainer>
  );
}
